/**
 * Defines the horizontal alignment of the thumbnails menu of the `ui5-media-gallery` component.
 * @public
 */
enum MediaGalleryMenuHorizontalAlign {

	/**
	 * Displays the menu on the left side of the target.
	 * @public
	 */
	Left = "Left",

	/**
	 * Displays the menu on the right side of the target.
	 * @public
	 */
	Right = "Right",
}

export default MediaGalleryMenuHorizontalAlign;
